import { useState } from "react";
import ContentManager from "../ContentManager";

const TABS = [
  ["facility_bay", "Fabrication Bays"],
  ["facility_logistics", "Logistics Cards"],
  ["facility_gallery", "Photo Gallery"],
];

const FacilitiesAdmin = () => {
  const [tab, setTab] = useState(TABS[0][0]);
  return (
    <div>
      <div className="mb-6 flex gap-2 flex-wrap" data-testid="fac-admin-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`fac-tab-${k}`}
            className={`px-4 py-2 text-[11px] font-display font-semibold uppercase tracking-widest border transition-colors ${tab === k ? "bg-[#0A1128] text-white border-[#0A1128]" : "bg-white text-slate-600 border-slate-300 hover:border-slate-500"}`}>
            {l}
          </button>
        ))}
      </div>
      {tab === "facility_bay" && <ContentManager type="facility_bay" title="Fabrication Bays" description="The three production bays shown on Facilities and Capabilities pages." />}
      {tab === "facility_logistics" && <ContentManager type="facility_logistics" title="Logistics Cards" description="Road / jetty / RO-RO transportation cards on the Facilities page." />}
      {tab === "facility_gallery" && <ContentManager type="facility_gallery" title="Facilities Photo Gallery" description="Photographs shown in the Facilities page gallery, in display order." />}
    </div>
  );
};

export default FacilitiesAdmin;
